import { getApiClient } from './AxiosService'

async function getPovratDokumentiService(data) {
  try {
    const result = await getApiClient(data.accessToken).get('povrat-dokumenti')
    if (result.status === 200 && result.data && result.data.code === 200) {
      return {
        isOk: true,
        data: result.data.data,
      }
    } else {
      return {
        isOk: false,
      }
    }
  } catch (error) {
    console.log('Error in getPovratDokumentiService:', error.response)
    return {
      isOk: false,
      status: error.response?.status,
      message: error.message,
    }
  }
}

async function createPovratDokumentService(data) {
  try {
    const result = await getApiClient(data.accessToken).post(
      'povrat-dokumenti',
      data,
    )
    if (result.status === 201 && result.data && result.data.code === 201) {
      return {
        isOk: true,
        data: result.data.data,
      }
    } else {
      return {
        isOk: false,
      }
    }
  } catch (error) {
    console.log('Error in createPovratDokumentService:', error.response)
    return {
      isOk: false,
      status: error.response?.status,
      message: error.message,
    }
  }
}

async function updatePovratDokumentService(data) {
  try {
    const result = await getApiClient(data.accessToken).put(
      `povrat-dokumenti/${data.id}`,
      data,
    )
    if (result.status === 200 && result.data && result.data.code === 200) {
      return {
        isOk: true,
        data: result.data.data,
      }
    } else {
      return {
        isOk: false,
      }
    }
  } catch (error) {
    console.log('Error in updatePovratDokumentService:', error.response)
    return {
      isOk: false,
      status: error.response?.status,
      message: error.message,
    }
  }
}

async function deletePovratDokumentService(data) {
  try {
    const result = await getApiClient(data.accessToken).delete(
      `povrat-dokumenti/${data.id}`,
    )
    if (result.status === 200 && result.data && result.data.success) {
      return {
        isOk: true,
      }
    } else {
      return {
        isOk: false,
      }
    }
  } catch (error) {
    console.log('Error in deletePovratDokumentService:', error.response)
    return {
      isOk: false,
      status: error.response?.status,
      message: error.message,
    }
  }
}

export {
  getPovratDokumentiService,
  createPovratDokumentService,
  updatePovratDokumentService,
  deletePovratDokumentService,
}
